module.exports = __webpack_public_path__ + "img/ramen.ae18a2af.png";